import React, { RefObject } from 'react';

export const Sizes = {
  FLEX: 'flex',
  LARGE: 'large',
  NORMAL: 'normal',
  TINY: 'tiny',
} as const;

export type Size = (typeof Sizes)[keyof typeof Sizes];
type VariantButton = 'primary' | 'functional' | 'default' | 'error';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: VariantButton;
  size?: Size;
  offHover?: boolean;
  buttonRef?: RefObject<HTMLButtonElement>;
}
